<form [formGroup]="form()">
    <app-card-content [headerColor]="false" icon="pi pi-graduation-cap" title="Pós-Graduação" subtitle="Dados do curso de pós-graduação">
        <div class="grid grid-cols-1 gap-4 mb-6">
            <div class="field">
                <label for="posNome" class="font-semibold block mb-2">Nome</label>
                <div class="grid grid-cols-[1fr_auto] gap-2">
                    <input pInputText id="posNome" formControlName="posNome" placeholder="Nome" class="w-full readonly-input" [readonly]="true" />
                    <p-button icon="pi pi-search" [disabled]="!modoEdicao()" (onClick)="pesquisarEscola.emit()"></p-button>
                </div>
                @if (campoInvalido('posNome')) {
                    <small class="erro-campo">{{ mensagemErroCampo('posNome') }}</small>
                }
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div class="field md:col-span-2">
                <label for="posDenominacaoCurso" class="font-semibold block mb-2">Denominação do Curso de Pós-Graduação</label>
                <div class="grid grid-cols-[1fr_auto] gap-2">
                    <p-select
                        id="posDenominacaoCurso"
                        formControlName="posDenominacaoCurso"
                        [options]="posDenominacaoOptions()"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Selecione"
                        [appendTo]="'body'"
                        (onShow)="openDenominacaoSelect.emit()"
                        [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                        [readonly]="!modoEdicao() || posDenominacoesCarregando()"
                    />
                    <p-button icon="pi pi-eye" [disabled]="!modoEdicao() || !form().get('posDenominacaoCurso')?.value || posDenominacoesCarregando()" pTooltip="Especialidades Relacionadas" (onClick)="abrirEspecialidades.emit()"></p-button>
                </div>
                @if (campoInvalido('posDenominacaoCurso')) {
                    <small class="erro-campo">{{ mensagemErroCampo('posDenominacaoCurso') }}</small>
                }
            </div>

            <div class="field">
                <label for="posComprovanteGraduacao" class="font-semibold block mb-2">Comprovante de Graduação</label>
                <p-select
                    [appendTo]="'body'"
                    id="posComprovanteGraduacao"
                    formControlName="posComprovanteGraduacao"
                    [options]="comprovanteGraduacaoOptions()"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione"
                    [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    [readonly]="!modoEdicao()"
                />
                @if (campoInvalido('posComprovanteGraduacao')) {
                    <small class="erro-campo">{{ mensagemErroCampo('posComprovanteGraduacao') }}</small>
                }
            </div>

            <div class="field">
                <label for="posDtInicioOferta" class="font-semibold block mb-2">Dt. Início Oferta</label>
                <p-inputmask id="posDtInicioOferta" formControlName="posDtInicioOferta" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                @if (campoInvalido('posDtInicioOferta')) {
                    <small class="erro-campo">{{ mensagemErroCampo('posDtInicioOferta') }}</small>
                }
            </div>

            <div class="field">
                <label for="posDtInicioCurso" class="font-semibold block mb-2">Dt. Início Curso</label>
                <p-inputmask id="posDtInicioCurso" formControlName="posDtInicioCurso" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                @if (campoInvalido('posDtInicioCurso')) {
                    <small class="erro-campo">{{ mensagemErroCampo('posDtInicioCurso') }}</small>
                }
            </div>

            <div class="field">
                <label for="posDtFimCurso" class="font-semibold block mb-2">Dt. Fim Curso</label>
                <p-inputmask id="posDtFimCurso" formControlName="posDtFimCurso" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                @if (campoInvalido('posDtFimCurso')) {
                    <small class="erro-campo">{{ mensagemErroCampo('posDtFimCurso') }}</small>
                }
            </div>

            <div class="field">
                <label for="posDtFormatura" class="font-semibold block mb-2">Dt. Formatura</label>
                <p-inputmask id="posDtFormatura" formControlName="posDtFormatura" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                @if (campoInvalido('posDtFormatura')) {
                    <small class="erro-campo">{{ mensagemErroCampo('posDtFormatura') }}</small>
                }
            </div>

            <div class="field">
                <label for="posCargaHoraria" class="font-semibold block mb-2">Carga Horária</label>
                <input pInputText id="posCargaHoraria" formControlName="posCargaHoraria" placeholder="Ex.: 360h" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-[12rem_1fr_auto] gap-2">
            <div class="field">
                <label for="posIdDocumento" class="font-semibold block mb-2">ID Documento</label>
                <input pInputText id="posIdDocumento" formControlName="posIdDocumento" placeholder="ID" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
            </div>
            <div class="field">
                <label for="posUrlDocumento" class="font-semibold block mb-2">URL do Documento de validação da Pós-Graduação</label>
                <input pInputText id="posUrlDocumento" formControlName="posUrlDocumento" placeholder="https://..." [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
            </div>
            <div class="flex items-end pb-1">
                <p-button icon="pi pi-external-link" [disabled]="!form().get('posUrlDocumento')?.value" (onClick)="abrirDocumentoPos()" />
            </div>
        </div>
    </app-card-content>
</form>

<p-dialog
    appDialogoPadrao="pi pi-paperclip"
    descricao="Documento anexado ao registro."
    [visible]="exibirDialogAnexo()"
    (visibleChange)="exibirDialogAnexo.set($event)"
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    header="Visualização de anexo"
    (onHide)="fecharDialogAnexo()"
>
    @if (blobAnexo(); as anexo) {
        <app-visualizador-pdf [src]="anexo" [fileName]="nomeArquivoAnexo" [showAll]="false"></app-visualizador-pdf>
    } @else {
        <div class="text-center text-color-secondary italic p-4">Nenhum anexo disponível para visualização.</div>
    }
</p-dialog>
